import { makeStyles } from '@material-ui/core/styles';
import React, { ElementType } from 'react';
import { Link as LinkUi } from '@material-ui/core';
import cx from 'classnames';

const useStyle = makeStyles(theme => ({
  root: {
    color: theme.palette.button.default,
    textDecoration: (prop: Pick<IProp, 'type'>) => (prop.type === 'underline' ? 'underline' : 'none'),
  },
}));

interface IProp {
  onClick: (e: React.MouseEvent) => void;
  type?: 'underline';
  className?: string;
  disabled?: boolean;
  component?: ElementType;
}

export const Link: React.FC<IProp> = ({
  onClick,
  type,
  children,
  className = '',
  disabled = false,
  component = 'button',
}) => {
  const classes = useStyle({ type });

  return (
    <LinkUi
      component={component}
      variant='body1'
      className={cx(classes.root, className)}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </LinkUi>
  );
};
